// Gift wrapping / note web components
// - Adds/removes gift wrap variant via cart_update (updates[id]=qty)
// - Stores cart attribute gift-wrapping + gift-note
// - Re-renders mini-cart sections when available

class GiftQuantity extends QuantityInput {
  constructor() {
    super();
  }

  init() {
    super.init();

    this.giftWrappingEl = document.querySelector('gift-wrapping');
    if (!this.giftWrappingEl) return;

    this.cartItemsSize = parseInt(this.getAttribute('cart-items-size') || '0', 10);
    this.giftWrapsInCart = parseInt(this.getAttribute('gift-wraps-in-cart') || '0', 10);

    this.itemsInCart =
      theme?.shopSettings?.giftwrapRate === 'flat'
        ? 1
        : parseInt(this.getAttribute('items-in-cart') || '0', 10);

    // If we have nothing but gift-wrap items in the cart.
    if (this.cartItemsSize === 1 && this.giftWrapsInCart > 0) {
      this.giftWrappingEl.removeGiftWrap();
    }
    // If we don't have the right amount of gift-wrap items in the cart.
    else if (this.giftWrapsInCart > 0 && this.giftWrapsInCart !== this.itemsInCart) {
      this.update();
    }
  }

  update() {
    this.input.value = this.itemsInCart;
    this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('gift-quantity', GiftQuantity);

class GiftWrapping extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector('mini-cart');

    // IMPORTANT: data-gift-wrap-id must be a VARIANT ID
    this.giftWrapId = this.dataset.giftWrapId;

    // Stored as a string from Liquid; normalize to boolean
    this.giftWrappingEnabled =
      !!this.dataset.giftWrapping && this.dataset.giftWrapping !== 'false';

    this.cartItemsSize = parseInt(this.getAttribute('cart-items-size') || '0', 10);
    this.giftWrapsInCart = parseInt(this.getAttribute('gift-wraps-in-cart') || '0', 10);

    this.itemsInCart =
      theme?.shopSettings?.giftwrapRate === 'flat'
        ? 1
        : parseInt(this.getAttribute('items-in-cart') || '0', 10);

    const checkbox = this.querySelector('[name="attributes[gift-wrapping]"]');
    if (checkbox) {
      checkbox.addEventListener('change', (event) => {
        event.target.checked ? this.setGiftWrap() : this.removeGiftWrap();
      });
    }

    // If giftWrapId is missing, fail loudly so you can spot it in console
    if (!this.giftWrapId) {
      console.warn('[GiftWrapping] Missing data-gift-wrap-id (must be variant id).');
      return;
    }

    // Auto-reconcile state on load (works for mini-cart + full cart page)
    // If we have nothing but gift-wrap items in the cart.
    if (this.cartItemsSize === 1 && this.giftWrapsInCart > 0) {
      this.removeGiftWrap();
    }
    // If we don't have the right amount of gift-wrap items in the cart.
    else if (this.giftWrapsInCart > 0 && this.giftWrapsInCart !== this.itemsInCart) {
      this.setGiftWrap();
    }
    // If we have a gift-wrap item in the cart but our gift-wrapping cart attribute has not been set.
    else if (this.giftWrapsInCart > 0 && !this.giftWrappingEnabled) {
      this.setGiftWrap();
    }
    // If we have no gift-wrap item in the cart but our gift-wrapping cart attribute has been set.
    else if (this.giftWrapsInCart === 0 && this.giftWrappingEnabled) {
      this.setGiftWrap();
    }
  }

  setGiftWrap() {
    const loadingOverlay = this.querySelector('.loading-overlay');
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');

    const sections = this.getSectionsToRender().map((s) => s.section);
    const body = JSON.stringify({
      updates: {
        [this.giftWrapId]: this.itemsInCart
      },
      attributes: {
        'gift-wrapping': true
      },
      sections,
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), body })
      .then((r) => r.json())
      .then((response) => {
        if (loadingOverlay) loadingOverlay.classList.add('hidden');

        if (document.body.classList.contains('template-cart')) {
          window.location.href = theme.routes.cart_url;
          return;
        }

        if (this.miniCart && typeof this.miniCart.renderContents === 'function') {
          this.miniCart.renderContents(response);
        }
      })
      .catch((e) => console.error(e));
  }

  removeGiftWrap() {
    const loadingOverlay = this.querySelector('.loading-overlay');
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');

    const sections = this.getSectionsToRender().map((s) => s.section);
    const body = JSON.stringify({
      updates: {
        [this.giftWrapId]: 0
      },
      attributes: {
        'gift-wrapping': '',
        'gift-note': ''
      },
      sections,
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), body })
      .then((r) => r.json())
      .then((response) => {
        if (loadingOverlay) loadingOverlay.classList.add('hidden');

        if (document.body.classList.contains('template-cart')) {
          window.location.href = theme.routes.cart_url;
          return;
        }

        if (this.miniCart && typeof this.miniCart.renderContents === 'function') {
          this.miniCart.renderContents(response);
        }
      })
      .catch((e) => console.error(e));
  }

  getSectionsToRender() {
    return [
      { id: 'mini-cart', section: 'mini-cart', selector: '.shopify-section' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'mobile-cart-icon-bubble', section: 'mobile-cart-icon-bubble', selector: '.shopify-section' },
      { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' }
    ];
  }
}
customElements.define('gift-wrapping', GiftWrapping);

class GiftNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'change',
      debounce((event) => {
        const body = JSON.stringify({ attributes: { 'gift-note': event.target.value } });
        fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), body });
      }, 300)
    );
  }
}
customElements.define('gift-note', GiftNote);